import { IDeleteProjetoImpressaoUseCase } from "../../../presentation/useCases/delete/delete_projeto_impressao_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteProjetoImpressaoUseCase
 */

export class DeleteProjetoImpressaoUseCase implements IDeleteProjetoImpressaoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoImpressao(request: { id: number }): Promise<void> {
    return await this.repository.deleteProjetoImpressao(request);
  }
}
